/**
 * @description 获取snp PlusView基座应用地址
 * @param {} env
 */

const plusViewEnvRefer = {
    'PROD': 'https://irsnp.com/micro/#/',
    'VER': 'https://snpver.midea.com/micro/#/',
    'UAT': 'https://snpuat.midea.com/micro/#/'
};

// let PlusViewURL = "https://localhost.midea.com:7001/";
// https://snpuat.midea.com/micro/#/
export const getPlusViewURL = (env) => {
    return plusViewEnvRefer[env] || 'https://localhost.midea.com:7001/';
};
